import { bclTwMerge } from 'bank-component-library';
import tw from '../../utilities/tw';

interface FooterStyles {
  footerDefault: string;
  footerLight: string;
  footerLinksContainerHalf: string;
  footerLinksContainerFull: string;
  footerLinkWrapper: string;
  flexLinkContainerLeftHalf: string;
  flexLinkContainerLeftFull: string;
  flexLinkContainerRightHalf: string;
  flexLinkContainerRightFull: string;
  footerLinkDefault: string;
  footerLinkLight: string;
  fdicWrapper: string;
  copyright: string;
}

const footerPadding = tw`relative py-7 px-6 sm:pt-4 pb-6 sm:px-6 xl:px-8`;
const flexLinkDisplay = tw`flex flex-wrap flex-col grow sm:flex-row`;
const footerLinkStyles = tw`text-body-md leading-1 font-bold tracking-wide hover:no-underline hover:border-b hover:pb-0.5 visited:no-underline visited:border-b visited:pb-0.5`;
const linkContainerStyles = tw`relative flex flex-col text-sm`;

const footerStyles: FooterStyles = {
  footerDefault: bclTwMerge(footerPadding, tw`bg-neutral-800`),
  footerLight: bclTwMerge(footerPadding, tw`bg-neutral-50`),
  footerLinksContainerHalf: bclTwMerge(
    linkContainerStyles,
    `justify-between flex-wrap gap-y-3 mb-3 md:mb-2 lg:max-w-screen-sm sm:flex-row sm:gap-x-6 sm:mr-24 sm:justify-start sm:gap-y-0 lg:gap-x-4 lg:gap-y-0 lg:mb-1`
  ),
  footerLinksContainerFull: bclTwMerge(
    linkContainerStyles,
    `flex-nowrap mb-4 gap-y-4 sm:gap-y-4 sm:mr-[106px] md:gap-x-12 md:flex-row xl:mr-[114px]`
  ),
  flexLinkContainerLeftHalf: bclTwMerge(
    flexLinkDisplay,
    tw`contents sm:mr-28 gap-y-3 sm:gap-y-0 sm:gap-x-12 lg:gap-y-2 lg:max-w-screen-sm xl:mr-32`
  ),
  flexLinkContainerLeftFull: bclTwMerge(
    flexLinkDisplay,
    tw`sm:max-w-screen-xs gap-y-4 sm:gap-x-12 lg:gap-y-4 lg:max-w-screen-sm xl:mr-32`
  ),
  flexLinkContainerRightHalf: bclTwMerge(
    flexLinkDisplay,
    tw`contents min-w-fit gap-y-3 sm:gap-x-12 sm:gap-y-2 lg:justify-end`
  ),
  flexLinkContainerRightFull: bclTwMerge(
    flexLinkDisplay,
    tw`min-w-fit gap-y-4 sm:gap-x-12 sm:gap-y-0 md:justify-end`
  ),
  footerLinkWrapper: tw`uppercase m-0 py-2 leading-1`,
  fdicWrapper: tw`absolute top-8 right-6 sm:top-6 xl:right-8`,
  footerLinkDefault: bclTwMerge(footerLinkStyles, tw`text-neutral-white`),
  footerLinkLight: bclTwMerge(footerLinkStyles, tw`text-neutral-800`),
  copyright: tw`block mt-6 sm:pt-0 sm:mt-3`,
};

export default footerStyles;
